import authRequest from "@/api/http/authRequest";

const base = "/admin/alimtalk/templates";
export default {
  list(params, cb, err) { authRequest.get(base, params, cb, err) },
  categories(cb, err) { authRequest.get(`${base}/categories`, {}, cb, err) },
  detail(id, cb, err) { authRequest.get(`${base}/${id}`, {}, cb, err) },
  sync(cb, err) { authRequest.post(`${base}/sync`, {}, cb, err) },
  syncDetail(templateCode, cb, err) { authRequest.post(`${base}/${templateCode}/sync`, {}, cb, err) },
  create(params, cb, err) { authRequest.post(base, params, cb, err) },
  update(id, params, cb, err) { authRequest.put(`${base}/${id}`, params, cb, err) },
  updateManagement(id, params, cb, err) { authRequest.put(`${base}/${id}/management`, params, cb, err) },
  delete(id, cb, err) { authRequest.delete(`${base}/${id}`, cb, err) },
  testSend(id, params, cb, err) { authRequest.post(`${base}/${id}/test-send`, params, cb, err) },
  preview(id, file, cb, err) {
    const form = new FormData(); form.append("file", file)
    authRequest.postWithFile(`${base}/${id}/recipients/preview`, form, cb, err)
  },
  previewRecipients(file, cb, err) {
    const form = new FormData(); form.append("file", file)
    authRequest.postWithFile(`${base}/recipients/preview`, form, cb, err)
  },
  bulkSend(id, recipients, cb, err) { authRequest.post(`${base}/${id}/bulk-send`, { recipients }, cb, err) },
}
